export default {"src":"/_next/static/media/hexwrench_64.54229908.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};